import { baseApi } from './baseApi';

export const roleApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRoles: builder.query({
      query: () => '/roles',
      providesTags: ['Role'],
    }),
    getRole: builder.query({
      query: (id) => `/roles/${id}`,
      providesTags: (result, error, id) => [{ type: 'Role', id }],
    }),
    createRole: builder.mutation({
      query: (data) => ({
        url: '/roles',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Role'],
    }),
    updateRole: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/roles/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Role'],
    }),
    updateRolePermissions: builder.mutation({
      query: ({ id, permissionIds }) => ({
        url: `/roles/${id}/permissions`,
        method: 'PUT',
        body: { permissionIds },
      }),
      invalidatesTags: ['Role'],
    }),
    getPermissions: builder.query({
      query: () => '/roles/all/permissions',
      providesTags: ['Role'],
    }),
  }),
});

export const {
  useGetRolesQuery,
  useGetRoleQuery,
  useCreateRoleMutation,
  useUpdateRoleMutation,
  useUpdateRolePermissionsMutation,
  useGetPermissionsQuery,
} = roleApi;

